import {useAppSelector} from '../../../store/store';
import buttonStyles from '../../../components/button/button.module.scss';
import formStyles from '../../../components/form/form.module.scss';
import {Button} from '../../../components/button/button';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import {Status} from '../../../enums/status.ts';
import {CenteredSpinner} from '../../../components/spinner/centered_spinner.tsx';
import {__} from '../../../support/lang/translations.ts';
import {classNames} from '../../../support/classnames.ts';
import {ShowElement} from '../../../components/utility/show_element_wrapper.tsx';
import {HideElement} from '../../../components/utility/hide_element_wrapper.tsx';

export function MileageTitle() {
    return (
        <>
            <h1>{__('appointment.mileage.title')}</h1>
            <h2>{__('appointment.mileage.subtitle')}</h2>
        </>
    );
}

interface ContentProps {
    mileage: number | null;
    brand?: string | null;
    onMileageChange: (mileage: number) => void;
}

export function MileageContent(props: ContentProps) {
    const customerInfo = useAppSelector((state) => state.customerInfo);

    if (customerInfo.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    return (
        <>
            {props.brand != null && <h3>{__('appointment.mileage.title_appointment', {brand: props.brand})}</h3>}
            <div className={classNames(formStyles.form, formStyles.form_centered)}>
                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__custom}>
                        <fieldset>
                            <label data-grid-column-start={1} data-grid-column-end={13}>
                                {__('appointment.mileage.fields.mileage')}
                                <input
                                    defaultValue={props.mileage || ''}
                                    type="number"
                                    onChange={(e) => {
                                        props.onMileageChange(Number.parseInt(e.target.value, 10));
                                    }}
                                    min={0}
                                    max={999999999}
                                    step={1}
                                    required={true}
                                    pattern="[0-9]"
                                />
                            </label>
                        </fieldset>
                    </div>
                </div>
            </div>
        </>
    );
}

interface FooterProps {
    onPreviousSlide: () => void;
    onNextSlide: () => void;
    nextIsDisabled: boolean;
}

export function MileageFooter(props: FooterProps) {
    return (
        <>
            <ShowElement size={'sm'}>
                <Button
                    className={buttonStyles.button_step}
                    type="button"
                    onClick={() => props.onPreviousSlide()}
                    colorType={ButtonColorType.Black}
                >
                    <i className="fa-light fa-chevron-left" />
                    <span>{__('appointment.mileage.footer.buttons.previous')}</span>
                </Button>
            </ShowElement>

            <HideElement size={'sm'}>
                <span />
            </HideElement>

            <Button
                className={buttonStyles.button_step}
                disabled={props.nextIsDisabled}
                type="button"
                onClick={() => props.onNextSlide()}
                colorType={ButtonColorType.Green}
            >
                <i className="fa-light fa-check" />
                <span>{__('appointment.mileage.footer.buttons.next')}</span>
            </Button>
        </>
    );
}
